import styled from 'styled-components'
import type { FlowType } from '../types/filesTab'
import DownloadButton from './Files/DownloadFileButton'

const FilesTabContent = styled.div`
  display: flex;
  height: 100%;
`

const List = styled.ul`
  list-style: none;
  li {
    padding-bottom: 1em;
  }
`

const FilesTab = ({ flow }: FlowType) => (
  <FilesTabContent>
    <List>
      {flow.data.storedFiles.map((x) => (
        <li key={x.filename}>
          <DownloadButton title={x.filename} fileId={x.storeID} />
        </li>
      ))}
    </List>
  </FilesTabContent>
)

export default FilesTab
